import EditEventForm from "../../components/Events/EditEventForm"


const EventsEdit = () => {
    return (
        <EditEventForm />
    )
}


export default EventsEdit